import {Component, ContentChildren, EventEmitter, Input, Output, QueryList} from '@angular/core';
import {MaiTabComponent} from '@shared/components/mai-tab/mai-tab.component';
import {MatTabChangeEvent} from "@angular/material/tabs";

@Component({
  selector: 'app-mai-tab-group',
  templateUrl: './mai-tab-group.component.html',
  styleUrls: ['./mai-tab-group.component.scss'],
})
export class MaiTabGroupComponent {
  @Input() tabGroupClass: 'square' | 'line' | 'box' = 'line';
  @Input() matTabStretch = false;
  @Input() selectedTabIndex = 0;
  @Output() tabChange = new EventEmitter<MatTabChangeEvent>();

  @ContentChildren(MaiTabComponent)
  children!: QueryList<MaiTabComponent>;

  get isJustOneChild() {
    return this.children.toArray().filter((value) => value.isPap).length === 1;
  }

  get childrenList() {
    return this.children.toArray().filter((value) => value.isPap);
  }
}
